import { gql } from '../../__generated__/gql'

export const STORE_SONG_DETAILS_QUERY = gql(`
  query storeSongDetails($id: Int!) {
    storeSong(id: $id) {
      id
      title
      seoKeywords
      seoDescription
      writer
      album {
        id
        name
        year
        primaryArtist {
          id
        }
        cover {
          medium
        }
      }
      artists {
        id
        name
      }
      bpm
      key
      timeSignature
      appleMusicUrl
      spotifyUrl
      vibe
      voice {
        id
        name
      }
      visibleInStore
    }
  }
`)
